/** bi上报白名单 */
export const REPORT_WHITE_LIST = [
  'main.area_click',
  'select-half.item_click',
  'multi-jump-container.jump',
];
